import { config } from 'config';
import TrackerCall from 'utils/TrackingCall';
import { createSession } from 'containers/VideoCall/CallStream';
import { useState, useEffect } from 'react';

export function useOpenTokSession(session: { id: string; token: string }) {
  const [opentok, setOpentok] = useState<unknown | undefined>();
  const [streams, setStreams] = useState<unknown[]>([]);
  const [isPresent, setIsPresent] = useState(false);
  const [hasConnected, setHasConnected] = useState(false);

  useEffect(() => {
    const { session: openTokSession } = createSession({
      apiKey: config.services.tokbox.api_key,
      sessionId: session.id,
      token: session.token,
      onStreamsUpdated: setStreams,
    });
    setOpentok(openTokSession);

    openTokSession.on('sessionConnected', (event: any) => {
      TrackerCall.debug('session connected', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
        }),
      });
    });
    openTokSession.on('sessionDisconnected', (event: any) => {
      TrackerCall.debug('session disconnected', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
        }),
      });
    });
    openTokSession.on('sessionReconnected', (event: any) => {
      TrackerCall.debug('session reconnected', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
        }),
      });
    });
    openTokSession.on('sessionReconnecting', (event: any) => {
      TrackerCall.debug('session reconnecting', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
        }),
      });
    });
    openTokSession.on('streamCreated', (event: any) => {
      setIsPresent(true);
      setHasConnected(true);

      TrackerCall.debug('stream created', {
        content: JSON.stringify({
          event: event,
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
          streamHasAudio: event.stream.hasAudio,
          streamHasVideo: event.stream.hasVideo,
          streamVideoType: event.stream.videoType,
        }),
      });
    });
    openTokSession.on('streamDestroyed', (event: any) => {
      setStreams([]);
      setIsPresent(false);

      TrackerCall.debug('stream destroyed', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
          streamReason: event.reason,
          streamHasAudio: event.stream.hasAudio,
          streamHasVideo: event.stream.hasVideo,
          streamVideoType: event.stream.videoType,
        }),
      });
    });
    openTokSession.on('streamPropertyChanged', (event: any) => {
      TrackerCall.debug('stream property changed', {
        content: JSON.stringify({
          sessionId: event.target.sessionId,
          currentState: event.target.currentState,
          previousState: event.target.previousState,
          changedProperty: event.changedProperty,
          newValue: event.newValue,
          oldValue: event.oldValue,
        }),
      });
    });

    return () => openTokSession.disconnect();
  }, []);

  return {
    opentok,
    streams,
    isPresent,
    hasConnected,
    setHasConnected,
    setIsPresent,
  };
}
